SipSignal Acceptable Use Policy <br /><br />
All use of SipSignal Services is subject to and conditioned upon compliance with
the following Acceptable Use Policy (“AUP”). If you have an Agreement with
SipSignal, this AUP is incorporated into and made a part of your Agreement with
SipSignal.
<br /><br />
This Acceptable Use Policy applies to all SipSignal Services. Please carefully
review the following to determine if the Services you have purchased are subject
to additional, service-specific prohibitions.
<br /><br />
<h2 class="legal__subtitle">1.Definitions</h2>
<br />
<ol class="legal__ordered-list">
  <li>
    1.1 "Service" – shall mean the products and services that are being provided
    to you as described in any quote or order form, including, but not limited
    to, SipSignal’s Uniﬁed Communication services, collaboration services, the
    Messaging Services, and any associated software, hardware or web-based
    platform. "Service" shall also include any additional Services provided to
    you as described in any addendum or amendment.
  </li>
</ol>
<br /><br />
A. The Services (including any device, system, network, or account used in
connection with the Services, or the SipSignal Network) may not be used to:
<br /><br />
<b>Illegal activity.</b> Violate any applicable law or regulation applicable to
the use of the Services. <br /><br />
<b>Resale Prohibited.</b> Engage in resale activities. You may not resell or
transfer your Service or your Device or provide a telephone service to anyone
else by using your SipSignal service or features of your SipSignal service
without ﬁrst obtaining our prior written consent. <br /><br />
<b>NO HIGH RISK USE.</b> Engage in high-risk use of the Services. The Services
may not be available in the event of a loss of power or internet connectivity,
or network congestion. The Services are not designed, intended, or recommended
for use in any situation where, in the normal course of use, service disruption
could result in personal injury or death (“high-risk use”). High-risk use is
prohibited except to the extent you have fail-safe alternatives in place at all
times. <br /><br />
<b>Infringing activity.</b> Infringe, misappropriate, or otherwise violate
SipSignal’s or anyone’s rights (including intellectual property, privacy,
personality, publicity, or otherwise; or display or use SipSignal’s marks
without consent or in violation of SipSignal policies. <br /><br />
<b>Minors.</b> Exploit or harm minors (e.g., expose them to inappropriate
content; ask for personally identifiable information without parental consent).
<br /><br />
<b>Malicious activity.</b> Transmit any material that contains viruses, time or
logic bombs, Trojan horses, worms, malware, spyware, or any other programs that
may be harmful or dangerous. <br /><br />
<b>Objectionable activity.</b> Act in an indecent, offensive, threatening,
harassing, defamatory, libelous, fraudulent, malicious, disruptive, tortious, or
other objectionable manner. <br /><br />
<b>Misrepresenting origin and/or identity.</b> Mislead recipients as to
Customer’s identity. Create a false caller ID (e.g., ID spoofing), forge
addresses or headers, or fraudulently undertake other technical measures to
misrepresent the origin or identity of the sender. <br /><br />
<b>Harvest information;</b> spam; bulk messages. Without consent: harvest or
collect information about third parties or End Users, or send bulk
communications. <br /><br />
<b>Excessive or unauthorized use.</b> Use any device, system, network, account,
plan, or the Services in an unauthorized manner or in excess of reasonable
business use (e.g. interfere, inhibit, compromise, or otherwise harm the
Services or the SipSignal Network (regardless of intent or knowledge)).
<br /><br />
<b>Unlimited Services.</b> SipSignal reserves the right to periodically review
usage levels of any unlimited service plans, including, but not limited to,
minutes, data, messages, and API calls ("Unlimited Plan(s)"), to ensure that you
are not using such service in violation of this AUP and if such an abuse or
violation is discovered to terminate or adjust the plan as appropriate. You
agree to use the Unlimited Plan for services of a quantity or duration
comparable to that of the average customer presently utilizing SipSignal’s
services and will not employ methods, devices or procedures to take advantage of
unlimited plans by using the services excessively or for means not intended by
SipSignal. Excessive use is deﬁned by SipSignal as use that substantially
exceeds the average volume or duration of calls, data or messages used by all
other SipSignal Unlimited Plan customers using the same service, or attempting
to originate or terminate multiple concurrent phone calls, faxes, or messages
through any single line of service. The following types of services are
speciﬁcally prohibited and may not be accessed through SipSignal’s unlimited
voice service plan: conference calling, monitoring services, data transmissions,
transmission of broadcasts or transmission of recorded material. SipSignal may
terminate your service or change your service plan if, in its sole discretion,
SipSignal determines that your use of the Unlimited Plan violates this
prohibition or is otherwise "unreasonable" or results in abuse of the Unlimited
Plan.Misrepresenting origin and/or identity. <br /><br />
<b>SHORT DURATION CALLS:</b> SipSignal reserves the right to charge all short
duration calls (calls under 10 seconds in length) a ten-cent (10¢) per call
assessment if SipSignal determines, in its sole discretion, that you have an
excessive volume (more than 10% of your total calls in any given month) of calls
that consist of such short duration calls. You agree that calls, as deﬁned
herein for billing purposes, shall include all call trafﬁc when accepted by
SipSignal or its underlying carriers for termination whether such calls are
terminated or not for any reason ("incomplete calls"). SipSignal will bill you
for all calls completed to SipSignal’s facility or equipment or that of
SipSignal’s underlying carriers regardless if the call is completed to the
called party. Accordingly, you understand your obligations in regards to
incomplete calls and agree that SipSignal shall incur no liability as a result
of or, in relation to, said incomplete call. <br /><br />
<b>Circumvent compliance or security.</b> Take advantage of, bypass, exploit,
defeat, disable, or otherwise circumvent limitations of the Services, security
mechanisms, or compliance with this AUP or any law. <br /><br />
<b>Interception.</b> Intercept, capture, sniff, monitor, modify, emulate,
decrypt, or redirect any communication or data for any purpose. <br /><br />
<b>Theft of Service.</b> You may not use or obtain our Service in any manner
that avoids SipSignal policies and procedures, including an illegal or improper
manner. You will notify us immediately in writing if your Device is stolen or if
you believe that your Service is being stolen, fraudulently used, or otherwise
being used in an unauthorized manner. When you notify us of one of these events,
you must provide your account number and a detailed description of the
circumstances of the theft, fraudulent use, or unauthorized use of Service. If
you fail to notify us in writing in a timely manner, we may disconnect your
service and levy additional charges on you. Until you notify us in writing, you
will remain liable for all use of our Service using a Device stolen from you and
any and all stolen, fraudulent or unauthorized use of the Service up through the
date notice is received by SipSignal. <br /><br />
B. In addition to the prohibitions described in (A) above, SipSignal Services,
(including any device, system, network, or account used in connection with the
Services, or the SipSignal Network) may not be used to:
<br /><br />
<b>Auto-dialing;</b> trunking; traffic pumping. Perform auto-dialing or
“predictive dialing”; trunk or forward your SipSignal phone or fax number to
other numbers that handle multiple simultaneous calls or to a private branch
exchange (PBX) or a key system; traffic pumping or access stimulation of calls
through the Services or the SipSignal Network. <br /><br />
The list above is not exhaustive or exclusive. For purposes of this AUP, “End
User” means an individual user of the Services, and may be a natural person, and
may include but is not limited to a Customer’s employees, consultants, clients,
external users, invitees, contractors and agents. Except as otherwise provided,
terms defined in the Agreement have the same meanings when used in this AUP.
<br /><br />
SipSignal may act immediately and without notice to suspend or terminate the
Services if, in SipSignal’s sole discretion, Customer’s or its End Users’ use of
the Services violates the terms of this Acceptable Use Policy.
<br /><br />
Customer may cancel any services purchased under this Agreement with written
notice to SipSignal within thirty (30) days of the date in which the purchase
becomes effective. Except as otherwise provided in the Agreement between the
Parties, in the event of a timely cancelation, Customer shall not owe any fees
or charges for the services being canceled in respect of any period subsequent
to the date of such written notice (except those arising from continued Usage),
and shall be entitled to a pro-rata refund of any prepaid and unused fees for
the services subject to the cancelation. All purchases are final after 30 days.
